import React, { createContext, useContext, useEffect, useState } from "react";

const CART_KEY = "kanchi_cart";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem(CART_KEY);
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
  }, [cart]);

  const addToCart = (item) => {
    setCart((prev) => {
      const existing = prev[item.id];

      return {
        ...prev,
        [item.id]: {
          id: item.id,
          name: item.name,
          price: item.final_price,
          image_url: item.image_url,
          quantity: existing ? existing.quantity + 1 : 1,
        },
      };
    });
  };

  const increaseQty = (id) => {
    setCart((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        quantity: prev[id].quantity + 1,
      },
    }));
  };

  const decreaseQty = (id) => {
    setCart((prev) => {
      const qty = prev[id].quantity - 1;

      if (qty <= 0) {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      }

      return {
        ...prev,
        [id]: {
          ...prev[id],
          quantity: qty,
        },
      };
    });
  };

  const removeItem = (id) => {
    setCart((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        increaseQty,
        decreaseQty,
        removeItem,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
